import { render } from "./pos_settings.vue?vue&type=template&id=08226806&scoped=true"
import script from "./pos_settings.vue?vue&type=script&lang=js"
export * from "./pos_settings.vue?vue&type=script&lang=js"

import "./pos_settings.vue?vue&type=style&index=0&id=08226806&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08226806"]])

export default __exports__